import { CommonEvents } from "@common/services/common-events";
import { isTRPCClientError } from "@common/utils/api-utils";

export function handleWebError(error: unknown, options?: { overrideTitle: string }) {
  console.error(error);

  if (typeof error === "string") {
    CommonEvents.emit("PUBLISH_TOAST", {
      title: "Error",
      content: error,
      titleColor: "negative",
    });
    return;
  }

  if (isTRPCClientError(error)) {
    CommonEvents.emit("PUBLISH_TOAST", {
      title: options?.overrideTitle ?? error.message ?? "API Error",
      content: options?.overrideTitle ? error.message : "",
      titleColor: "negative",
    });
    return;
  }

  if (error instanceof Error) {
    CommonEvents.emit("PUBLISH_TOAST", {
      title: error.name ?? "Error",
      content: error.message ?? "Unknown error",
      titleColor: "negative",
    });
    return;
  }
  CommonEvents.emit("PUBLISH_TOAST", {
    title: "Error",
    content: "Unknown error",
    titleColor: "negative",
  });
}
